import { ApiRoutes } from "consts/enpoints/api";
import { fetchApi } from "infrastructure/api";

export const getTransactionTrackingDeliveryCodes = (queryString = '') =>
    fetchApi(`${ApiRoutes.GetTransactionTrackingDeliveryCodes}${queryString}`);
